export default {
  name: 'AsterX',

  methods: {
    flushLocallySavedParametersForMission() {
      const json = localStorage.getItem(
        'EvasiveManeuverDashboardLocalParameters'
      )
      const missionId = localStorage.getItem('currentMissionId')
      if (json) {
        const parameters = JSON.parse(json)
        if (parameters && parameters[missionId]) {
          delete parameters[missionId]
          localStorage.setItem(
            'EvasiveManeuverDashboardLocalParameters',
            JSON.stringify(parameters)
          )
        }
      }
    },

    restoreLocallySavedParameters(params) {
      const json = localStorage.getItem(
        'EvasiveManeuverDashboardLocalParameters'
      )
      if (json) {
        const parameters = JSON.parse(json)
        const currentMissionId = localStorage.getItem('currentMissionId')
        if (parameters && parameters[currentMissionId]) {
          const parsedParameters = parameters[currentMissionId]
          params.forEach((param) => {
            if (parsedParameters[param]) {
              this[param] = parsedParameters[param]
            }
          })
        }
      }
    },

    updateLocallySavedParameters(params) {
      let json = localStorage.getItem('EvasiveManeuverDashboardLocalParameters')
      if (!json) {
        const missionId = localStorage.getItem('currentMissionId')

        const parameters = {}
        if (!parameters[missionId]) {
          parameters[missionId] = {}
        }
        params.forEach((param) => {
          parameters[missionId][param] = this[param]
        })
        localStorage.setItem(
          'EvasiveManeuverDashboardLocalParameters',
          JSON.stringify(parameters)
        )
      }
      const missionId = localStorage.getItem('currentMissionId')
      const parameters = JSON.parse(json)
      params.forEach((param) => {
        parameters[missionId][param] = this[param]
      })
      localStorage.setItem(
        'EvasiveManeuverDashboardLocalParameters',
        JSON.stringify(parameters)
      )
    }
  }
}
